<h1>Introduction</h1>

<p>
  I was interested in <a href="https://genuary.art/">Genuary</a> in 2023, and did
  some of the challenges.
</p>
